(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/bingo-react/components/bingo-wrapper-paper/assets/javascripts/bingo-wrapper-paper.js') >= 0) return;  svs.modules.push('/modules/bingo-react/components/bingo-wrapper-paper/assets/javascripts/bingo-wrapper-paper.js');

'use strict';

const _svs$ui$ReactCard = svs.ui.ReactCard,
  Card = _svs$ui$ReactCard.Card,
  CardBody = _svs$ui$ReactCard.CardBody;
const BingoWrapperPaper = _ref => {
  let children = _ref.children;
  return React.createElement(Card, {
    className: "bingo-wrapper-paper"
  }, React.createElement(CardBody, {
    className: "bingo-wrapper-paper__body"
  }, children));
};
setGlobal('svs.bingo_react.components.bingoWrapperPaper.BingoWrapperPaper', BingoWrapperPaper);

 })(window);